<style>
@import '../../custom/css/admin-navigation.css';
</style>

<template>
  <div class="cliente">
    <div class="row m-0" v-if="dadosUsuario !== null">
      <div class="col-lg-3 col-md-12 p-0 bg-gray-1">
        <div class="menu-area-restrita col-12 mt-4">
          <Topic :text="'Informações'" :icon="'fas fa-user-circle'" />
          <BasicItem
            :text="'Meus Dados'"
            :icon="'fas fa-list-alt'"
            :routeName="'gerente-meus-dados'"
          />
          <!-- <BasicItem
            :text="'Novo lojista'"
            :icon="'fas fa-user-plus'"
            :routeName="'novo-lojista-gerente'"
          /> -->
          <BasicItem
            :text="'Recomendar lojista'"
            :icon="'fas fa-wallet'"
            :routeName="'pedidos-lojista-gerente'"
          />
          <!-- <BasicItem
            :text="'Simular acesso do lojista'"
            :icon="'fas fa-sign-out-alt'"
            :routeName="'simular-acesso-lojista-gerente'"
          /> -->
          <BasicItem
            :text="'Sair'"
            :icon="'fas fa-power-off'"
            :routeName="'sair'"
          />
        </div>
      </div>
      <div class="col-lg-8 col-md-12 marginBox">
        <div class="conteudo-area-restrita">
          <router-view />
        </div>        
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Item from '../../components/Menu/Item.vue';
import Topic from '../../components/Menu/Topic.vue';
import BasicItem from '../../components/Menu/BasicItem.vue';

export default {
  name: 'GerenteConta',
  components: {
    Item,
    Topic,
    BasicItem,
  },
  data: () => ({
    cotacoesContagem: 0,
    permissionClerk: [],
  }),
  computed: {
    ...mapGetters([
      // Mapeamento de getters
    ]),
    ...mapState({
      // Mapeamento de states
      token: (state) => state.token,
      dadosUsuario: (state) => state.dadosUsuario
    }),
  },
  created() {
  },
  methods: {
  },

  
};
</script>

<style scoped>
@media screen and (max-width: 800px) {
  .marginBox {
    padding: 0 15px;
  }
}
</style>
